var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResourcesFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 127 127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#726fb3",
    d: "M126.79,64.09c0-2.68-1.67-5.09-4.36-6.28l-18.35-8.14,18.35-8.12c2.7-1.19,4.37-3.6,4.37-6.28,0-2.68-1.67-5.09-4.36-6.28L67.21,4.49c-2.32-1.03-5.1-1.03-7.42,0L4.58,28.95c-2.69,1.19-4.37,3.6-4.37,6.28,0,2.68,1.67,5.09,4.37,6.28l18.35,8.13-18.35,8.13c-2.69,1.19-4.37,3.6-4.37,6.28,0,2.68,1.67,5.09,4.37,6.28l17.09,7.57-17.1,7.58c-2.69,1.19-4.37,3.6-4.37,6.28,0,2.68,1.67,5.09,4.37,6.28l55.21,24.46c1.16.51,2.43.77,3.71.77s2.55-.26,3.71-.77l55.21-24.43c2.7-1.19,4.37-3.6,4.37-6.28,0-2.68-1.67-5.09-4.36-6.28l-17.1-7.59,17.09-7.56c2.7-1.19,4.37-3.6,4.37-6.28Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourcesFilled);
export default __webpack_public_path__ + "static/media/resources-filled.1875f709e890900c06fbc76461aa2265.svg";
export { ForwardRef as ReactComponent };